import { Team__Joeles } from "../teams/Joeles";
import { Team__FlintTropics } from "../teams/FlintTropics";
import { Team__Natalias } from "../teams/Natalias";
import { Team__Llamas } from "../teams/Llamas";
import { Team__Grizzlies } from "../teams/Grizzlies";
import { Team__UTPaquime } from "../teams/UTPaquime";
import { Team__IrrigacionAgricola } from "../teams/IrrigacionAgricola";
import { Team__Potros } from "../teams/Potros";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__Adrianes } from "../teams/Adrianes";
import { Team__DublanCity } from "../teams/DublanCity";
import { Team__Pistons } from "../teams/Pistons";

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 27,
  penaltyGoals: 0,
  isWinner: false,
};

const FlintTropics = {
  team: Team__FlintTropics,
  playingPlayers: [],

  goals: 28,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 34,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias_2 = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 18,
  penaltyGoals: 0,
  isWinner: false,
};

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 37,
  penaltyGoals: 0,
  isWinner: false,
};

const Grizzlies = {
  team: Team__Grizzlies,
  playingPlayers: [],

  goals: 41,
  penaltyGoals: 0,
  isWinner: false,
};

const Grizzlies_2 = {
  team: Team__Grizzlies,
  playingPlayers: [],

  goals: 16,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 43,
  penaltyGoals: 0,
  isWinner: false,
};

const IrrigacionAgricola = {
  team: Team__IrrigacionAgricola,
  playingPlayers: [],

  goals: 43,
  penaltyGoals: 0,
  isWinner: false,
};

const Potros = {
  team: Team__Potros,
  playingPlayers: [],

  goals: 54,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 38,
  penaltyGoals: 0,
  isWinner: false,
};

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 28,
  penaltyGoals: 0,
  isWinner: false,
};

const DublanCity = {
  team: Team__DublanCity,
  playingPlayers: [],

  goals: 46,
  penaltyGoals: 0,
  isWinner: false,
};

const Pistons = {
  team: Team__Pistons,
  playingPlayers: [],

  goals: 45,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada2 = {
  jornadaPosition: 2,
  matches: [
    {
      team1: Joeles,
      team2: FlintTropics,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "11:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Natalias,
      team2: Llamas,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Grizzlies,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: IrrigacionAgricola,
      team2: Potros,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: PecanBros,
      team2: Adrianes,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Natalias_2,
      team2: Grizzlies_2,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: DublanCity,
      team2: Pistons,

      isCompleted: true,
      isPlaying: false,
      day: "Martes",
      date: "2026-07-28",
      time: "17:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
